<template>
  <el-container>
    <el-aside width="auto">
      <ccMenu />
    </el-aside>
    <el-container>
      <el-header height="80"><ccHead /></el-header>
      <el-main><ccMain />
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import ccMenu from "./cc-menu";
import ccHead from "./cc-head";
import ccMain from "./cc-main";

export default {
  name: "Layout",
  components: {
    ccMenu,
    ccHead,
    ccMain,
  },
};
</script>
<style scoped>
.el-container {
  height: 100%;
}
.el-header{
  padding: 0px 10px;
}
.el-main {
  overflow: hidden;
  padding: 0;
}
</style>
